(function ($, root, undefined) {
  $(function () {
    var windowHeight, windowWidth;
    window.addEventListener('DOMContentLoaded', function () {
      function windowSize() {
        windowHeight = window.innerHeight ? window.innerHeight : $(window).height();
        windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
      }

      windowSize();
      if (windowWidth > 1025) {
        const textElements = document.querySelectorAll('body:not(.template-collection) .product-info .product-title');
        for (const textElement of textElements) {
          const maxLength = 50;
          const lines = [];
          var count = 0;
          var line1 = [],
            line2 = [];
          var line1String, line2String;

          const textElementArray = textElement.innerText.split(' ');
          for (let i = 0; i < textElementArray.length; i++) {
            count += textElementArray[i].length;
            if (count <= maxLength) {
              line1.push(textElementArray[i])
            } else {
              line2.push(textElementArray[i])
            }
          }

          if (line1.length > 0) {
            line1String = line1.join(' ');
            lines.push(line1String);
          }
          if (line2.length > 0) {
            line2String = line2.join(' ');
            lines.push(line2String);
          }

          // for (let i = 0; i < textElement.innerText.length; i += maxLength) {
          //   lines.push(textElement.innerText.substr(i, maxLength));
          // }

          textElement.innerText = '';

          lines.forEach(line => {
            const divElement = document.createElement('div');
            divElement.innerHTML = "<div class='anim_wrap'>" + line + "</div>";
            textElement.appendChild(divElement);
          });
        }
      }

      let productTitleWrap = document.querySelectorAll('.product-info .product-title');
      let productTitleAnimWrap = document.querySelectorAll('.product-info .product-title .anim_wrap');
      let animBoxWrap = document.querySelectorAll('.shopify-section--related-products .product-info .product-title .anim_wrap');
      let productBreadcrumbsWrap = document.querySelector('.product-info .product_breadcrumbs_wrap');
      let compositionWrap = document.querySelector('.product-info .composition_wrap');
      let productPrice = document.querySelector('.product-info .price-list');
      let galleryAnimWrap = document.querySelector('.left-content .product_gallery_wrap .gallery_anim_wrap');
      let productGalleryImg = document.querySelector('.product_gallery_wrap .one_img img');
      let reviewWrap = document.querySelector('.product-info .reviews-io-rating-bar-widget');
      let allRightSide = document.querySelectorAll('.product-coffee-right > *');

      gsap.timeline().to(animBoxWrap, { duration: 0.5, y: 0 })
        .to(productTitleWrap, { duration: 0.5, opacity: 1 })
        .to(productTitleAnimWrap, { duration: 0.3, y: 0 })
        .to(productBreadcrumbsWrap, { duration: 0.3, opacity: 1 })
        .to(compositionWrap, { duration: 0.2, opacity: 1 })
        .to(productPrice, { duration: 0.5, opacity: 1 }, '<')
        .to(galleryAnimWrap, { duration: 0.5, height: "0px" }, '<')
        .to(productGalleryImg, { duration: 0.7, scale: 1 }, '<')
        .to(reviewWrap, { duration: 0.7, opacity: 1, delay: 0.2 }, '<')
        .to(allRightSide, { duration: 0.5, opacity: 1, y: 0, stagger: { each: 0.1 }, }, '<')
    });

    var lastScrollTop = 0;
    $(window).scroll(function (event) {
      var st = $(this).scrollTop();
      if ($(window).width() >= 768) {
        if (st > lastScrollTop) {
          $('.shopify-section--sticky').addClass('active')
        } else {
          $('.shopify-section--sticky').removeClass('active')
        }
        lastScrollTop = st;
      } else {
        if ($('body').hasClass('template-product')) {
          let infoPosittion = $('.shopify-section--main-product .product-info').offset().top + $('.shopify-section--main-product .product-info').outerHeight();
          //console.log(infoPosittion);
          if (st > lastScrollTop && st > infoPosittion) {
            $('.shopify-section--sticky').addClass('active')
          } else {
            $('.shopify-section--sticky').removeClass('active')
          }
          lastScrollTop = st;
        }
      }
    });

    $('buy-buttons').click(function () {
      $('.shopify-section--sticky').removeClass('active')
    })

    $('.product-sticky-list-item, .select-weight').click(function () {
      let target = '.' + $(this).data('target');
      if (target != '') {
        if (windowWidth < 768) {
          $('html, body').animate({
            scrollTop: $(target).offset().top - 120
          }, 500);
        } else {
          $('html, body').animate({
            scrollTop: $(target).offset().top - 68
          }, 500);
        }
      }
    });

    $(window).scroll(function () {
      var Scroll = $(window).scrollTop();
      $('.product-sticky-list-item').each(function (index) {
        let target = '.' + $(this).data('target');
        var sectionOffsetTop = $(target).offset().top;
        var sectionOffsetTopBottom = $(target).outerHeight() + sectionOffsetTop;
        //console.log('sectionOffsetTop (' + target + ') :' + sectionOffsetTop);
        //console.log('sectionOffsetTopBottom (' + target + ') :' + sectionOffsetTopBottom);
        //console.log('Scroll: ' + Scroll);
        if (Scroll >= sectionOffsetTop && Scroll <= sectionOffsetTopBottom) {
          $(this).addClass('active')
        } else {
          $(this).removeClass('active')
        }
      });
    });

    $('.free-shipping-text .close-text').click(function (e) {
      e.preventDefault();
      $(this).closest('.free-shipping-text').hide();
    })

    $('.close-notifications-bar').click(function (e) {
      e.preventDefault();
      $(this).closest('.notifications-bar').hide();
      if (!$('body').hasClass('template-index')) {
        $('.notifications-bar').closest('#main').css('padding-top', 0)
      }
      setCookie('notifications-bar', '1', 1);
    })

    if (getCookie('notifications-bar') != 1) {
      $('.notifications-bar').show();
      if (!$('body').hasClass('template-index')) {
        $('.notifications-bar').closest('#main').css('padding-top', $('.notifications-bar').outerHeight() + 'px')
      }
    }

    function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
      let name = cname + "=";
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    /*=====================================
    =         gallery swiper        =
    =====================================*/
    let swiper = new Swiper('.product_gallery_wrap', {
      pagination: {
        el: ".product_gallery_wrap .swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        init: function (swiper) {
          swiper.slides.forEach((slide, index) => {
            const slideVideo = slide.querySelector('video');
            const iframeWrap = slide.querySelector('.iframe_wrap');
            const iframe = iframeWrap ? iframeWrap.getAttribute('data-video') : '';

            if (index == 0) {
              if (slideVideo) slideVideo.play();
              if (iframeWrap) iframeWrap.insertAdjacentHTML('beforeend', iframe);
            }
          });
        },
        slideChange: function (swiper) {
          swiper.slides.forEach((slide, index) => {
            const slideVideo = slide.querySelector('video');
            const iframeWrap = slide.querySelector('.iframe_wrap');
            const iframe = iframeWrap ? iframeWrap.getAttribute('data-video') : '';

            if (index == swiper.activeIndex) {
              if (slideVideo) slideVideo.play();
              if (iframeWrap) {
                iframeWrap.innerHTML = '';
                iframeWrap.insertAdjacentHTML('beforeend', iframe);
                if (iframeWrap.querySelector('iframe'))
                  iframeWrap.querySelector('iframe').src = iframeWrap.querySelector('iframe').src + '&autoplay=1';
              }
            } else {
              if (slideVideo) slideVideo.pause();
              if (iframeWrap) iframeWrap.innerHTML = '';
            }
          });
        }
      }
    });

    window.addEventListener('DOMContentLoaded', () => {
      //console.log('loaded');
      const videos = document.querySelectorAll('.video-item');
      for (const video of videos) {
        handleVideoSources(video);

        if (video.classList.contains('video-js')) {
          const player = videojs(video, {
            controlBar: {
              volumePanel: {
                inline: false
              },
              pictureInPictureToggle: true
            },
            playbackRates: [0.5, 1, 1.5, 2]
          });
          if (video.poster != '' && video.getAttribute('data-poster') != '')
            player.poster(video.poster);
        }

        if (!video.classList.contains('slide-show'))
          videoObserver(video);
      }

      initVideoSwiper();
      menuBtnInit();
      singleProductVariants();

      const products = document.querySelectorAll('.single_product');

      ///coffe selector
      // coffeeSelectorInit(products);

      tagsSwiperInit();

      ///emptyStateClear
      const emptyStateBtn = document.querySelector('.empty_state_btn');
      if (emptyStateBtn) {
        emptyStateBtn.addEventListener('click', () => {
          resetFilters(true);
          resetFilters(false);
        });
      }
    });

    function intersectionCallback(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (entry.intersectionRatio >= 0.7) {
            if (!entry.target.getAttribute('autoplay-start') && entry.target.getAttribute('data-autoplay')) {
              entry.target.setAttribute('autoplay-start', true);
              if (entry.target.playerId)
                videojs(entry.target.playerId).autoplay('muted');
            }
          } else {
            if (entry.target.playerId)
              videojs(entry.target.playerId).pause();
          }
        }
      });
    }

    function buildThresholdList() {
      const thresholds = [];
      const numSteps = 20;

      for (let i = 1.0; i <= numSteps; i++) {
        const ratio = i / numSteps;
        thresholds.push(ratio);
      }

      thresholds.push(0);
      return thresholds;
    }


    function videoObserver(video) {
      if (!video) return;

      const options = {
        root: null,
        rootMargin: '0px',
        threshold: buildThresholdList()
      }

      const observer = new IntersectionObserver(intersectionCallback, options);
      observer.observe(video);
    }

    function handleVideoSources(video) {
      const source = video.querySelector('source');
      const sourceSrc = source.getAttribute('data-src');
      const sourceSm = source.getAttribute('data-src-sm') ? source.getAttribute('data-src-sm') : sourceSrc;
      const sourceXs = source.getAttribute('data-src-xs') ? source.getAttribute('data-src-xs') : sourceSrc;

      const posterSrc = video.getAttribute('data-poster');
      const posterSrcSm = video.getAttribute('data-poster-sm') ? video.getAttribute('data-poster-sm') : posterSrc;
      const posterSrcXs = video.getAttribute('data-poster-xs') ? video.getAttribute('data-poster-xs') : posterSrc;

      if (window.innerWidth < 1025 && window.innerWidth > 767) {
        source.src = sourceSm;
        if (posterSrcSm != '')
          video.poster = posterSrcSm;
      } else if (window.innerWidth < 768) {
        source.src = sourceXs;
        if (posterSrcXs != '')
          video.poster = posterSrcXs;
      } else {
        source.src = sourceSrc;
        if (posterSrc != '')
          video.poster = posterSrc;
      }
    }

    function initVideoSwiper() {
      const videosSecton = document.querySelectorAll('.img_video_slider_section');
      for (const videoSection of videosSecton) {
        const time = videoSection.getAttribute('data-time') ? parseInt(videoSection.getAttribute('data-time')) * 1000 : 5000;
        const videoSwipers = new Swiper('.img_video_slider_section .swiper', {
          speed: 1000,
          spaceBetween: 50,
          autoHeight: true,
          autoplay: {
            delay: time
          },
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
          },
          navigation: {
            nextEl: '.img_video_slider_section .swiper-button-next',
            prevEl: '.img_video_slider_section .swiper-button-prev'
          },
          on: {
            init: function (swiper) {
              swiper.slides.forEach((slide, index) => {
                const slideVideo = slide.querySelector('video');
                if (slideVideo) slideVideo.load();
                if (index == 0) {
                  if (slideVideo) slideVideo.play();
                }
              });
            },
            slideChange: function (swiper) {
              swiper.slides.forEach((slide, index) => {
                const slideVideo = slide.querySelector('video');
                if (index == swiper.activeIndex) {
                  if (slideVideo) slideVideo.play();
                } else {
                  if (slideVideo) slideVideo.pause();
                }
              });
            }
          }
        });
      }
    }

    function menuBtnInit() {
      const menuBtns = document.querySelectorAll('.menu_close_btn');
      for (const menuBtn of menuBtns) {
        menuBtn.addEventListener('click', () => {
          const dropDowns = document.querySelectorAll('.Dropdownmenu');
          const menuItems = document.querySelectorAll('.HorizontalList__Item');
          for (const dropDown of dropDowns) {
            dropDown.setAttribute('aria-hidden', true);
            dropDown.classList.remove('full_menu');
          }
          for (const menuItem of menuItems) {
            menuItem.classList.remove('is-expanded')
          }
        });
      }
    }

    function waitForObjectInWindow(objectName) {
      return new Promise((resolve, reject) => {
        const intervalId = setInterval(() => {
          if (window[objectName]) {
            clearInterval(intervalId);
            resolve(window[objectName]);
          }
        }, 100);
      });
    }

    async function productSubscription() {
      const reChargeWidget = await waitForObjectInWindow('Recharge');
      // 0: "shop"
      // 1: "widgets"
      // 2: "init"
      // 3: "eventService"

      const subscriptions = document.querySelectorAll('.subscription_product_cont');

      subscriptions.forEach((subscription, index) => {
        const productID = subscription.getAttribute('data-id');
        const place = subscription.getAttribute('data-place');
        subscription.setAttribute('data-index', index);

        if (window.innerWidth < 1025 && (place === 'modal2' || place === 'modal' || place === 'menu')) return;

        const config = {
          productId: parseInt(productID), // Required
          injectionParent: `.subscription_product_cont[data-index="${index}"] .subscription_product_wrap`, // The node that will have the widget injected in
          injectionMethod: 'prepend', // How will the widget be injected 
          selectors: {
            price: [`.subscription_product_cont[data-index="${index}"] .button_price_value`], // the selectors that will be updated based on subscription
            variant: [`.subscription_product_cont[data-index="${index}"] .variant_select`] // The variants to watch for to update the subscription prices
          }
        }
        const widget = reChargeWidget.createWidget(config);

        setTimeout(() => {
          const inputs = subscription.querySelectorAll(`.subscription_product_wrap input`);
          const selects = subscription.querySelectorAll(`.subscription_product_wrap select`);
          for (const input of inputs) {
            const newIndex = input.id + '_' + index;
            input.id = newIndex;
            input.closest('.rc-radio').querySelector('label').setAttribute('for', newIndex);
          }

          for (const select of selects) {
            const newIndex = select.id + '_' + index;
            select.id = newIndex;
          }
          try {
            jQuery(`.subscription_product_cont[data-index="${index}"] .subscription_product_wrap select`).each(function () {
              jQuery(this).selectBoxIt({
                autoWidth: false,
                showEffect: "slideDown",
                hideEffect: "slideUp",
                dynamicPositioning: false,
                showEffectOptions: "down",
                showFirstOption: true,
                isMobile: function isMobile() {
                  return false; // (/iPhone|iPod|iPad|Android|BlackBerry|Opera Mini|IEMobile/).test(navigator.userAgent);
                }
              }).mouseleave(function (e) {
                e.stopPropagation();
              });
            });
          } catch (ex) {
            //console.log(ex);
          }

          if (place === 'page') {
            const rcPlans = subscription.querySelectorAll(`.subscription_product_wrap .rc-selling-plans`);
            for (const rcPlan of rcPlans) {
              const firstLink = document.createElement('div');
              const secondLink = document.createElement('div');
              firstLink.classList.add('subscription_tooltip_btn');
              firstLink.setAttribute('data-target', 'tooltip_drawer_shipping');
              firstLink.innerHTML = 'How subscriptions work?';
              secondLink.classList.add('subscription_tooltip_btn');
              secondLink.setAttribute('data-target', 'tooltip_drawer_coffee_roasting');
              secondLink.innerHTML = 'How Much Coffee Should I Get?';

              rcPlan.appendChild(firstLink);
              rcPlan.appendChild(secondLink);

              firstLink.addEventListener('click', openTooltip, false);
              secondLink.addEventListener('click', openTooltip, false);
            }
          }
        }, 1000);
      });
    }

    //productSubscription();

    var waitForEl = function (selector, callback) {
      if (jQuery(selector).length) {
        callback();
      } else {
        setTimeout(function () {
          waitForEl(selector, callback);
        }, 100);
      }
    };

    waitForEl('.shopify-section--main-product .rc-widget', function () {
      if ($('.tool-tip-popup-subscriptions').length > 0) {
        $('.subscription-radio').append($('.tool-tip-popup-subscriptions'));
        //$('.tool-tip-popup-subscriptions').insertAfter('.subscription-radio')
        $('.tool-tip-popup-subscriptions').show();
      }
      //var reChargeWidget = new Recharge;
      //let formattedVariantPrices = Object.values(Recharge.widgets)[0].config.formattedVariantPrices;
      //console.log(formattedVariantPrices);
      //console.log(typeof Recharge);
      checkChoosenSubscription()
    });

    function checkChoosenSubscription() {
      var valChecked = $('input[name="purchaseOption"]:checked').val();
      var price, formattedVariantPrices = Object.values(Recharge.widgets)[0].config.formattedVariantPrices;

      if (valChecked == 'subscription') {
        $('.rc-widget').addClass('choosen-subscription');
        $('.rc-selling-plans').insertBefore($('.tool-tip-popup-subscriptions'));
        var selectRcVal = $('select.rc-selling-plans-dropdown__select').val();
        $('.product-info').find('input[name="selling_plan"]').prop("disabled", false).val(selectRcVal);

        for (var key in formattedVariantPrices) {
          if (key == $('.shopify-section--main-product .shopify-product-form input[name="id"]').val()) {
            price = formattedVariantPrices[key].discounted;
          }
        }
        $('.shopify-section--main-product .buy-buttons .button_price_value .money').text(price)
      } else {
        $('.rc-widget').removeClass('choosen-subscription');
        $('.product-info').find('input[name="selling_plan"]').prop("disabled", true);

        for (var key in formattedVariantPrices) {
          if (key == $('.shopify-section--main-product .shopify-product-form input[name="id"]').val()) {
            price = formattedVariantPrices[key].unit;
          }
        }
        $('.shopify-section--main-product .buy-buttons .button_price_value .money').text(price)
      }

      $('input[name="purchaseOption"]').change(function () {

        if ($(this).val() == 'subscription') {
          $('.rc-widget').addClass('choosen-subscription');
          $('.rc-selling-plans').insertBefore($('.tool-tip-popup-subscriptions'));
          var selectRcVal = $('select.rc-selling-plans-dropdown__select').val();
          $('.product-info').find('input[name="selling_plan"]').prop("disabled", false).val(selectRcVal);

          for (var key in formattedVariantPrices) {
            if (key == $('.shopify-section--main-product .shopify-product-form input[name="id"]').val()) {
              price = formattedVariantPrices[key].discounted;
            }
          }
          $('.shopify-section--main-product .buy-buttons .button_price_value .money').text(price)
        } else {
          $('.rc-widget').removeClass('choosen-subscription');
          $('.product-info').find('input[name="selling_plan"]').prop("disabled", true);

          for (var key in formattedVariantPrices) {
            if (key == $('.shopify-section--main-product .shopify-product-form input[name="id"]').val()) {
              price = formattedVariantPrices[key].unit;
            }
          }
          $('.shopify-section--main-product .buy-buttons .button_price_value .money').text(price)
        }
      });
    }

    // $('.tool-tip-popup-links a').click(function (e) {
    //   e.preventDefault();
    //   openTooltipPopup($(this));
    // });

    // function openTooltipPopup(e) {
    //   var target = e.attr('data-target');
    //   $('tool-tip-popup-drawer').addClass('active');
    //   $('.tool-tip-popup-content').load(target + ' #main');
    // }

    function openTooltip(e) {
      const target = e.target.getAttribute('data-target');
      const tooltip = document.querySelector(`.${target}`);

      if (tooltip) {
        gsap.fromTo(tooltip, {
          display: 'none',
          opacity: 0
        }, {
          display: 'block',
          opacity: 1,
          duration: 0.3,
          ease: 'power2.inOut',
        });
        tooltip.classList.add('tooltip_drawer_open');
      }
    }

    function singleProductVariants() {
      const radios = document.querySelectorAll('.product-info .variant-picker input[type="radio"]');
      let select;
      
      if (document.querySelector('.product-info .variant-picker input[name="option2"]')?.type !== "radio") {
        select = document.querySelector('.product-info .variant-picker input[name="option2"]');
      }
      
      if (document.querySelector('.product-info .variant-picker input[name="option1"]').type !== "radio") {
        select = document.querySelector('.product-info .variant-picker input[name="option1"]');
      }
      
      const variantSelect = document.querySelector('.product-info .variant-picker .variant_select');
      const formAddToCartId = document.querySelector('.shopify-section--main-product .shopify-product-form input[name="id"]');
      const priceAddToCart = document.querySelector('.shopify-section--main-product .buy-buttons .button_price_value .money');
      if (select || radios) {
        let selectValue = select ? select.value : null;
        if (selectValue)
          selectValue = selectValue.toLowerCase().replaceAll(' ', '-');
        let radioValue;

        for (const radio of radios) {
          if (radio.checked) radioValue = radio.value;
          radio.addEventListener('change', () => {
            radioValue = radio.value;
            updateQaValue(variantSelect, selectValue, radioValue, formAddToCartId, priceAddToCart);
          });
        }

        ///selectboxit uses jquery events :/
        if (select) {
          $(select).selectBoxIt({
            autoWidth: false,
            showEffect: "slideDown",
            hideEffect: "slideUp",
            dynamicPositioning: false,
            showEffectOptions: "down",
            showFirstOption: false,
            isMobile: function isMobile() {
              return false;
            }
          }).change(function () {
            selectValue = select.value.toLowerCase().replaceAll(' ', '-');
            updateQaValue(variantSelect, selectValue, radioValue, formAddToCartId, priceAddToCart);
          });
        }
      }
    }

    selectSubScribe(0);
    function selectSubScribe(c) {
      $(document).on("click", "label.rc-radio", function () {
        $(this).find('.rc-selling-plans-dropdown__select').hide();

        setTimeout(() => {
          if ($('select.rc-selling-plans-dropdown__select').length) {
            const selectRc = document.querySelector('select.rc-selling-plans-dropdown__select');
            $(selectRc).selectBoxIt({
              autoWidth: false,
              showEffect: "slideDown",
              hideEffect: "slideUp",
              dynamicPositioning: false,
              showEffectOptions: "down",
              showFirstOption: true,
              isMobile: function isMobile() {
                return false;
              }
            }).change(function () {
              $(selectRc).closest('.product-info').find('input[name="selling_plan"]').val($(selectRc).val()).prop("disabled", false);
            });
          } else {
            selectSubScribe(c + 1)
          };
        }, 100);
      })

      setTimeout(() => {
        if ($('select.rc-selling-plans-dropdown__select').length) {
          const selectRc = document.querySelector('select.rc-selling-plans-dropdown__select');
          $(selectRc).selectBoxIt({
            autoWidth: false,
            showEffect: "slideDown",
            hideEffect: "slideUp",
            dynamicPositioning: false,
            showEffectOptions: "down",
            showFirstOption: true,
            isMobile: function isMobile() {
              return false;
            }
          }).change(function () {
            $(selectRc).closest('.product-info').find('input[name="selling_plan"]').val($(selectRc).val()).prop("disabled", false);
          });
        } else {
          selectSubScribe(c + 1)
        };
      }, 1000);
    }

    /*
      param @ wholeElement = <span class="money">$192.00 AUD</span>
      param @ price = $336.00 AUD
    */
  function getElementContentByWholeElementAndUpdatePrice(wholeElement, price) {
    if (!wholeElement) {
      return null
    }
    const divType = wholeElement.localName
    const className = wholeElement.className
    const elements = document.querySelectorAll(divType + '.' + className)
    if (elements.length > 0) {  
      elements.forEach(div => {
        div.textContent = price
      })
    } else {
        return null
    }
  }

    function updateQaValue(variantSelect, val0 = '', val1 = '', formAddToCartId, priceAddToCart) {
      if (!variantSelect) {
        return
      }
      let i;
      let valueSelected, price, percentage, priceDiscounted, priceUnit;
      
      for (i = 0; i < variantSelect.length; i++) {
        const opt = variantSelect.options[i];
        const opt1 = opt.getAttribute("data-prodid1");
        const opt2 = opt.getAttribute("data-prodid2");
        //const price = opt.getAttribute("data-price");
        const valChecked = $('input[name="purchaseOption"]:checked').val() ? $('input[name="purchaseOption"]:checked').val() : null
        /* CDSD-28201 31/01/24 - on recharge products prices do not update when switching between variants previously this was 
        * if (((opt1 == val0) && (opt2 == val1)) || ((opt1 == val1) && (opt2 == val0))) 
        * However these options do not always have values, so we will just run this loop for every product regardless.
        * most products are just single variants, but the code below looks safe and have added chaining on the selectors. 
        * the nested conditions are hard to work though
        */
        const isVariantSelected =  ((opt1 == val0) && (opt2 == val1)) || ((opt1 == val1) && (opt2 == val0))
        if (
            (valChecked == 'subscription' && isVariantSelected) || (isVariantSelected && valChecked == 'onetime')
        ) {
          opt.disabled = false;
          opt.selected = 'selected';
          valueSelected = opt.getAttribute("value");

          if (valChecked == 'subscription') {
            waitForEl('.shopify-section--main-product .rc-widget', function () {
              let formattedVariantPrices = Object.values(Recharge.widgets)[0].config.formattedVariantPrices;
              let widgetSettings = Object.values(Recharge.widgets)[0].widgetSettings;
              let onetimeMessage = widgetSettings.onetime_message;
              let subscribeMessage = widgetSettings.subscribe_message;
              //console.log(Recharge)
              setTimeout(function () {
                //price = $('.shopify-section--main-product .rc-widget .rc-radio__price').text();
                for (var key in formattedVariantPrices) {
                  if (key == $('.shopify-section--main-product .shopify-product-form input[name="id"]').val()) {
                    priceDiscounted = formattedVariantPrices[key].discounted;
                    priceUnit = formattedVariantPrices[key].unit;
                    percentage = Object.values(formattedVariantPrices[key].formattedSellingPlanPrices)[0].discountValue;
                    //console.log(percentage);
                  }
                }

                $('.shopify-section--main-product .onetime-radio .rc-radio__label')?.text(onetimeMessage + ' ' + priceUnit)
                $('.shopify-section--main-product .subscription-radio .rc-radio__subscription')?.html(subscribeMessage + ' ' + percentage + '%')
                $('.shopify-section--main-product .subscription-radio .rc-radio__price')?.html(' ' + priceDiscounted)
                // need to make sure all buttons are updated
                document.querySelectorAll('button > .button_price_value .money').forEach(buttonPrice => {
                  buttonPrice.textContent = priceDiscounted
                })
                priceAddToCart.textContent = priceDiscounted;
              }, 100)
            });
          } else {
            if (valChecked == 'onetime') {
              waitForEl('.shopify-section--main-product .rc-widget', function () {
                let formattedVariantPrices = Object.values(Recharge.widgets)[0].config.formattedVariantPrices;
                let widgetSettings = Object.values(Recharge.widgets)[0].widgetSettings;
                let onetimeMessage = widgetSettings.onetime_message;
                let subscribeMessage = widgetSettings.subscribe_message;
                setTimeout(function () {
                  //price = $('.shopify-section--main-product .rc-widget .rc-radio__price').text();
                  for (var key in formattedVariantPrices) {
                    if (key == $('.shopify-section--main-product .shopify-product-form input[name="id"]').val()) {
                      priceDiscounted = formattedVariantPrices[key].discounted;
                      priceUnit = formattedVariantPrices[key].unit;
                      percentage = Object.values(formattedVariantPrices[key].formattedSellingPlanPrices)[0].discountValue;
                      //console.log(percentage);
                    }
                  }
                  $('.shopify-section--main-product .onetime-radio .rc-radio__label')?.text(onetimeMessage + ' ' + priceUnit)
                  $('.shopify-section--main-product .subscription-radio .rc-radio__subscription')?.html(subscribeMessage + ' ' + percentage + '%')
                  $('.shopify-section--main-product .subscription-radio .rc-radio__price')?.html(' ' + priceDiscounted)
                  priceAddToCart.textContent = priceUnit;
                  // need to make sure all buttons are updated
                  document.querySelectorAll('button > .button_price_value .money').forEach(buttonPrice => {
                    buttonPrice.textContent = priceUnit
                  })
                }, 100)
              });
            } else {
              price = opt.text.split("-")[1].trim();
              // We need to update all prices not just the one. As there is many templates using 1 JS file
              // some prices will be missed. So we will loop over all pricing elements now and update everything.
              getElementContentByWholeElementAndUpdatePrice(priceAddToCart, price)
            }
          }
        }
      }

      if (valueSelected) {
        formAddToCartId.value = valueSelected;
      }

      if (price) {
        setTimeout(function () {
          priceAddToCart.textContent = price;
        }, 100)
      }

      const event = new Event('change');
      variantSelect.dispatchEvent(event);
    }

    function hideFilters() {
      const filterBtn = document.querySelector('.filter_btn');
      const filtersWrap = document.querySelector('.filters_wrap');
      let toHide = false;

      if (!filterBtn && !filtersWrap) return false;

      if (filterBtn.classList.contains('active')) {
        toHide = true;
        filterBtn.classList.remove('active');
        gsap.to(filtersWrap, {
          display: 'none',
          opacity: 0,
          maxHeight: 0,
          duration: 0.7,
          ease: 'power2.inOut'
        });
      }

      return toHide;
    }

    function hideCoffeeSelector() {
      const coffeeSelectorBtn = document.querySelector('.coffee_selector_btn');
      const coffeeSelectorWrap = document.querySelector('.coffee_selector_wrap');
      let toHide = false;

      if (!coffeeSelectorBtn) return false;

      if (coffeeSelectorBtn.classList.contains('active')) {
        toHide = true;
        coffeeSelectorBtn.classList.remove('active');
        gsap.to(coffeeSelectorWrap, {
          display: 'none',
          opacity: 0,
          maxHeight: 0,
          duration: 0.7,
          ease: 'power2.inOut'
        });
      }

      return toHide;
    }

    ////COFFE SELECTOR///
    function getSiblings(elem, parentSlector) {
      let siblings = [];
      for (const sibling of elem.closest(parentSlector).children) {
        if (sibling !== elem) {
          siblings.push(sibling);
        }
      }

      return siblings;
    }

    function coffeeSelectorInit(products) {
      const coffeeSelectorWrap = document.querySelector('.coffee_selector_wrap');
      const coffeeSelectorBtn = document.querySelector('.coffee_selector_btn');
      const coffeeSelectorHeaders = document.querySelectorAll('.single_coffee_selector_header');
      const coffeeSelectorContents = document.querySelectorAll('.single_coffee_selector_content');
      const closeFiltersBtns = document.querySelectorAll('.close_filters_js');

      if (!coffeeSelectorWrap) return;

      if (coffeeSelectorBtn) {
        coffeeSelectorBtn.addEventListener('click', () => {
          if (window.innerWidth > 767) {
            let delay = 0;
            if (coffeeSelectorBtn.classList.contains('active')) {
              coffeeSelectorBtn.classList.remove('active');
              gsap.to(coffeeSelectorWrap, {
                display: 'none',
                opacity: 0,
                maxHeight: 0,
                duration: 0.5,
                ease: 'power2.inOut'
              });
            } else {
              coffeeSelectorBtn.classList.add('active');
              if (hideFilters()) delay = 0.8;
              gsap.to(coffeeSelectorWrap, {
                display: 'block',
                opacity: 1,
                maxHeight: 2000,
                duration: 1,
                delay: delay,
                ease: 'power2.inOut'
              });
            }
          } else {
            gsap.to(coffeeSelectorWrap, {
              display: 'block',
              opacity: 1,
              duration: 0.5,
              ease: 'power2.inOut'
            });
          }
        });
      }

      if (window.innerWidth < 768) {
        for (const btn of closeFiltersBtns) {
          btn.addEventListener('click', () => {
            gsap.to(coffeeSelectorWrap, {
              display: 'none',
              opacity: 0,
              duration: 0.5,
              ease: 'power2.inOut'
            });
          });
        }
      }

      coffeeSelectorHeaders.forEach((item, index) => {
        item.addEventListener('click', () => {
          if (item.classList.contains('active')) {
            item.classList.remove('active');
            gsap.to(coffeeSelectorContents[index], {
              display: 'none',
              opacity: 0,
              maxHeight: 0,
              duration: 0.5,
              ease: 'power2.inOut',
              onComplete: () => {
                coffeeSelectorContents[index].classList.remove('active');
              }
            });
          } else {
            const siblings = getSiblings(item.parentNode, '.coffee_selector_filters');

            for (const sibling of siblings) {
              const siblingContent = sibling.querySelector('.single_coffee_selector_content');

              if (sibling.querySelector('.single_coffee_selector_header')) {
                sibling.querySelector('.single_coffee_selector_header').classList.remove('active');
              }

              if (siblingContent) {
                gsap.to(siblingContent, {
                  display: 'none',
                  opacity: 0,
                  maxHeight: 0,
                  duration: 0.5,
                  ease: 'power2.inOut',
                  onComplete: () => {
                    siblingContent.classList.remove('active');
                  }
                });
              }
            }

            item.classList.add('active');
            gsap.to(coffeeSelectorContents[index], {
              display: 'block',
              opacity: 1,
              maxHeight: 162,
              duration: 0.5,
              ease: 'power2.inOut',
              onComplete: () => {
                coffeeSelectorContents[index].classList.add('active');
              }
            });
          }
        });
      });

      ///filters
      coffeeSelectorFilters(products);
    }


    function coffeeSelectorFilters(products) {
      const filtersWrap = document.querySelectorAll('.single_coffee_selector_filter');
      const filters = document.querySelectorAll('.products_filter');
      const coffeeFilters = document.querySelectorAll('.coffee_selector_filter');
      const gr1Checkboxes = document.querySelectorAll('.coffee_selector_filter[name="coffee_filter_1"]');
      const gr2Checkboxes = document.querySelectorAll('.coffee_selector_filter[name="coffee_filter_2"]');
      const gr3Checkboxes = document.querySelectorAll('.coffee_selector_filter[name="coffee_filter_3"]');
      const viewItemsWrap = document.querySelector('.coffee_selector_wrap .view_items_wrap');
      const viewItemsNr = document.querySelectorAll('.coffee_selector_wrap .coffee_selector_nr');


      for (const item of coffeeFilters) {
        item.addEventListener('change', () => {
          if (Array.from(filters).filter(checkbox => checkbox.checked).length)
            resetFilters(false);

          const filteredProducts = coffeeFilterElements(
            gr1Checkboxes,
            gr2Checkboxes,
            gr3Checkboxes,
            products,
            viewItemsWrap,
            viewItemsNr,
            filtersWrap,
            filters
          );
        });
      }

      if (viewItemsWrap) {
        const viewItemsBtn = viewItemsWrap.querySelector('.view_items');
        const viewItemsBtnClear = viewItemsWrap.querySelector('.coffee_selector_clear');

        if (window.innerWidth > 767 && viewItemsBtn) {
          viewItemsBtn.addEventListener('click', () => {
            smoothScroll('.products_list', 1000, 60);
          });
        }

        if (viewItemsBtnClear) {
          viewItemsBtnClear.addEventListener('click', () => {
            resetFilters(true);
          });
        }
      }
    }
    ///END OF COFFE SELECTOR////

    function tagsSwiperInit() {
      if (window.innerWidth < 767) {
        const blogSwiper = new Swiper('.blog_taglist_swiper', {
          loop: false,
          freeMode: true,
          slidesPerView: 'auto',
          spaceBetween: 0
        });
      }
    }


    function smoothScroll(target, duration, offset = 0) {
      const targetElement = document.querySelector(target);
      const targetPosition = targetElement.getBoundingClientRect().top;
      const startPosition = window.pageYOffset;
      const distance = targetPosition + window.innerHeight - startPosition - offset;
      let startTime = null;

      function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
      }

      function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      };

      requestAnimationFrame(animation);
    }
  })
})(jQuery, this);